import { useAppDispatch, useAppSelector } from 'app/hooks';
import Spinner from 'components/Spinner/Spinner';
import { DateTime } from 'luxon';
import { EditProfile } from 'pages/EditProfile/EditProfile';
import { Orders } from 'pages/Orders/Orders';
import { useEffect } from 'react';
import { Outlet, Route, Routes, useLocation, useNavigate } from 'react-router';
import {
  DASHBOARD_PROFILE_EDIT_PROFILE,
  DASHBOARD_PROFILE_ORDERS,
  EDIT_PROFILE,
  ORDERS,
  ROOT,
} from 'routes/routes';
import { getUser } from 'services/auth/auth.service';
import {
  ProfileNavButtonHome,
  ProfileNavButtonOrders,
  ProfileNavButtonProfile,
  colors,
} from 'styles';
import { H2, H3, H4, P1, P2 } from '../../styles/FontStyles';
import { Div, Img, Separator, UserImageCircle } from '../../styles/Styles';
import { ProfileNavButton } from './Profile.styled';
import countries from 'lib/countries';

export const Profile = () => {
  const { loading, user } = useAppSelector((state) => state.authentication);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      dispatch(getUser());
    }
  }, [dispatch]);

  const formattedDate = DateTime.fromISO(user?.dateCreated ?? '').toFormat(
    'MMM yyyy'
  );

  if (user)
    return (
      <>
        {loading && <Spinner fullscreen={true} transparent />}

        <Div $flex $gap='40px' $width='100%' $columnSM>
          <Div
            $width='35%'
            $widthSM='100%'
            $flex
            $columnSM
            $gap='40px'
            $gapSM='20px'
          >
            <Div $width='58px' $widthSM='auto' $flexSM $centerSM>
              <Div $box $p='10px' $gap='16px' $flex $column $rowSM>
                <ProfileNavButton
                  $selected={false}
                  onClick={() => navigate(ROOT)}
                >
                  <ProfileNavButtonHome />
                </ProfileNavButton>
                <ProfileNavButton
                  $selected={
                    location.pathname === DASHBOARD_PROFILE_EDIT_PROFILE
                  }
                  onClick={() => navigate(DASHBOARD_PROFILE_EDIT_PROFILE)}
                >
                  <ProfileNavButtonProfile />
                </ProfileNavButton>
                <ProfileNavButton
                  $selected={location.pathname === DASHBOARD_PROFILE_ORDERS}
                  onClick={() => navigate(DASHBOARD_PROFILE_ORDERS)}
                >
                  <ProfileNavButtonOrders />
                </ProfileNavButton>
              </Div>
            </Div>
            <Div $width='100%' $box $flex $center $column>
              <UserImageCircle
                image={user.profileImage}
                avatar
                avatarSize='60px'
                size='180px'
                margin='0 0 20px 0'
              />
              <H3 center mb='5' color={colors.white}>
                {user.firstName} {user.lastName}
              </H3>
              <H4 mb='5' color={colors.white}>
                @{user.username}
              </H4>
              <P1 mb='10' color={colors.white}>
                Member since: {formattedDate}
              </P1>
              <Separator $m='20px 0' />
              <H3 mb='20' color={colors.white}>
                {countries.map(({ flag, code }, i) => {
                  if (code === user.countryCode) {
                    return (
                      <Img $height={'25px'} src={flag} key={i} alt={code} />
                    );
                  }
                })}{' '}
                {user.country}
              </H3>
              <Div $flex $gap='12px' $alignCenter $width='100%'>
                <Div $box $p='15px' $width='50%'>
                  <H2 center color={colors.white}>
                    {user.totalOrders ? user.totalOrders : 0}
                  </H2>
                  <P2 center color={colors.white}>
                    Total Orders
                  </P2>
                </Div>
                <Div $box $p='15px' $width='50%'>
                  <H2 center color={colors.white}>
                    0
                  </H2>
                  <P2 center color={colors.white}>
                    USDC Total
                  </P2>
                </Div>
              </Div>
            </Div>
          </Div>

          <Outlet />
        </Div>
      </>
    );
};
